import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl,maxPath,createQuestionPath,createSelectionPath,createAnswerPath} from "../../../../../../apiUrl"
import {useLocation, useNavigate} from "react-router-dom";
export const QuestionManageComponent = ({original,translate}) => {
    const [processedData, setProcessedData] = useState([]);

    const mappingData = (original, translate) => {
        console.log(original, translate);
        const originalArray = original.split(/[.\n]/).map(it=>it.trim()).filter(it=>it !== '');
        const translateArray = translate.split(/[.\n]/).map(it=>it.trim()).filter(it=>it !== '');
        const data = originalArray.map((item, index) => ({
            original: item,
            translate: translateArray[index],
        }))
        return data.map(item => ({
            originalText: item.original,
            translateText: "(번역된 내용)" + item.translate,
            exampleText: "(정답예시)" + item.translate,
        }));
    };

    useEffect(() => {
        console.log('original',original);
        console.log('translate',translate);
        if (translate === '') return;
        const newData = mappingData(original, translate);
        setProcessedData(newData);
    }, [original, translate]);

    const {state} = useLocation()
    const navigate = useNavigate()
    const handleSubmit = async () => {

        const maxResponse = await axios.get(`${restUrl}/${maxPath}`);
        const maxNum = maxResponse.data[0].max;

        const problemArray = []
        const selectionArray = []
        const answerArray = []

        processedData.forEach((item, idx) => {
            problemArray.push({
                id: maxNum + idx,
                problem: item.originalText,
                test_id: state.testId,
                category_id: 2
            });
            selectionArray.push({
                problem_id: maxNum + idx,
                selection: item.translateText,
            });
            answerArray.push({
                problem_id: maxNum + idx,
                answer: item.exampleText,
            });
        })
        await axios.post(`${restUrl}/${createQuestionPath}`, problemArray)
        await axios.post(`${restUrl}/${createSelectionPath}`, selectionArray)
        await axios.post(`${restUrl}/${createAnswerPath}`, answerArray)
        alert('저장되었습니다.')
        navigate(-1)
    }

    const onChange = (index, type, event) => {
        const {value} = event.target;
        setProcessedData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                [type]: value,
            };
            return newData;
        });
    };

    if (processedData.length === 0) {
        return null;
    }

    return (<>
        <h1>original : {original}</h1>
        <table>
        <thead className={`flex  gap-3`}><tr>
            {["원문", "번역된 내용", "에디터"].map((item, index) => (
                <th key={index}>{item} </th>
            ))}
        </tr></thead>
        <tbody>
            {processedData.map((items, index) => (<tr key={'qnoecw'+index}>
                {Object.keys(items).map((item,ind) =>
                    <td key={`qnoecw${index}${ind}`}>
                        <textarea defaultValue={item.originalText}
                            onChange={(e) =>
                                onChange(index, 'originalText', e)}>
                            {/*원문*/}
                        </textarea>
                </td>
                )}
        </tr>))}
        </tbody>
        </table>
        <button
            className={`p-3 bg-slate-900 text-white`} onClick={() => {
            handleSubmit().then()
        }}>제출하기
        </button>
    </>);
}